// Trả về steps theo hàm để hỗ trợ i18n
export const getDashboardTourSteps = (t) => [
    {
      selector: '[data-tour="drawer-dashboard"]',
      content: t("tour.dashboard.drawer"),
    },
    {
      selector: '[data-tour="dashboard-group-filter"]',
      content: t("tour.dashboard.group-filter"),
    },
    {
      selector: '[data-tour="dashboard-employees-chart"]',
      content: t("tour.dashboard.employees-chart"),
    },
    {
      selector: '[data-tour="dashboard-devices-chart"]',
      content: t("tour.dashboard.devices-chart"),
    },
    {
      selector: '[data-tour="dashboard-calendar"]',
      content: t("tour.dashboard.calendar"),
    },
    {
      selector: '[data-tour="dashboard-info-table"]',
      content: t("tour.dashboard.info-table"),
    },
  ];